var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 112,
    viewBox: "0 0 103 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.056 45.4353C74.0899 45.4353 74.967 45.7958 75.6881 46.5169C76.4091 47.2379 76.7697 48.1031 76.7697 49.1129V64.6179C76.7697 65.653 76.4092 66.5294 75.6881 67.2506C74.967 67.9716 74.0899 68.3322 73.056 68.3322C72.023 68.3322 71.1512 67.9717 70.4413 67.2506C69.7328 66.5295 69.3776 65.653 69.3776 64.6179V49.1129C69.3776 48.103 69.7382 47.2379 70.4593 46.5169C71.1804 45.7958 72.0462 45.4353 73.056 45.4353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1994 31.5164L40.6392 26.7936C40.4712 26.4809 40.531 26.2412 40.8191 26.0726C41.1319 25.9272 41.3722 26.0008 41.5401 26.2883L44.1361 31.049C46.4204 30.039 48.8364 29.5331 51.3841 29.5331C53.9324 29.5331 56.3486 30.0391 58.632 31.049L61.2281 26.2883C61.3968 26.0008 61.6371 25.9278 61.9491 26.0726C62.2379 26.2419 62.2977 26.4809 62.129 26.7936L59.5687 31.5164C62.1648 32.8404 64.2324 34.6842 65.7709 37.0519C67.3093 39.4209 68.0788 42.0097 68.0788 44.8229H34.7257C34.7257 42.0104 35.4953 39.4215 37.0336 37.0519C38.5721 34.6842 40.6278 32.8404 43.1994 31.5164ZM58.0012 38.3859C58.2781 38.6634 58.6088 38.8015 58.9932 38.8015C59.3783 38.8015 59.7023 38.6634 59.9666 38.3859C60.2308 38.1097 60.363 37.7803 60.363 37.3946C60.363 37.0102 60.2308 36.6802 59.9666 36.4033C59.7023 36.1271 59.3776 35.989 58.9932 35.989C58.6088 35.989 58.2781 36.1271 58.0012 36.4033C57.725 36.6809 57.5863 37.0102 57.5863 37.3946C57.587 37.7797 57.7257 38.1097 58.0012 38.3859ZM42.8031 38.3859C43.0679 38.6634 43.3926 38.8015 43.7764 38.8015C44.1616 38.8015 44.4922 38.6634 44.7685 38.3859C45.0453 38.1097 45.1834 37.7803 45.1834 37.3946C45.1834 37.0102 45.0453 36.6802 44.7685 36.4033C44.4922 36.1271 44.1616 35.989 43.7764 35.989C43.392 35.989 43.068 36.1271 42.8031 36.4033C42.5386 36.6809 42.4067 37.0102 42.4067 37.3946C42.4067 37.7797 42.5387 38.1097 42.8031 38.3859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9355 70.1348C67.9355 71.2416 67.5512 72.1785 66.7823 72.9474C66.0128 73.7163 65.0758 74.1007 63.9697 74.1007H61.3013L61.2647 82.2868C61.2647 83.3205 60.9042 84.1983 60.1832 84.9195C59.4621 85.6406 58.5963 86.0011 57.5871 86.0011C56.5539 86.0011 55.6762 85.6406 54.9551 84.9195C54.2339 84.1983 53.8734 83.3206 53.8734 82.2868V74.1015H48.8976V82.2868C48.8976 83.3205 48.5372 84.1983 47.816 84.9195C47.0949 85.6406 46.2179 86.0011 45.184 86.0011C44.1508 86.0011 43.2731 85.6406 42.552 84.9195C41.8309 84.1983 41.4705 83.3206 41.4705 82.2868V74.1015H38.766C37.6844 74.1015 36.7595 73.717 35.9892 72.9481C35.2205 72.1792 34.8359 71.2423 34.8359 70.1355V46.1198H67.9355V70.1348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7136 45.4353C30.7236 45.4353 31.5887 45.7905 32.3098 46.499C33.0308 47.2087 33.3914 48.0805 33.3914 49.1129V64.6179C33.3914 65.653 33.0309 66.5294 32.3098 67.2506C31.5887 67.9717 30.7229 68.3322 29.7136 68.3322C28.6804 68.3322 27.8027 67.9717 27.0816 67.2506C26.3605 66.5294 26 65.653 26 64.6179V49.1129C26 48.0804 26.3605 47.2087 27.0816 46.499C27.8027 45.7905 28.6804 45.4353 29.7136 45.4353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_694",
    x: 0.0500622,
    y: 0.0500011,
    width: 102.67,
    height: 111.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_694",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.f0f56fde8dd11364f8b6a52b9d8ef770.svg";
export { ForwardRef as ReactComponent };